/** Vékony fetch-burkoló az /api/v1 végpontokhoz: JSON, same-origin cookie, tipizált hiba. */

export class ApiError extends Error {
  status: number;
  code: string;
  detail: unknown;

  constructor(status: number, detail: unknown) {
    const d = (detail ?? {}) as { code?: string; message?: string };
    super(d.message ?? (typeof detail === "string" ? detail : `HTTP ${status}`));
    this.status = status;
    this.code = d.code ?? (status === 401 ? "unauthenticated" : status === 422 ? "validation" : "error");
    this.detail = detail;
  }
}

export const API_BASE = "/api/v1";

export async function api<T>(
  path: string,
  init: { method?: string; body?: unknown; signal?: AbortSignal } = {},
): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: init.method ?? "GET",
    credentials: "same-origin",
    headers: init.body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    signal: init.signal,
  });
  const text = await res.text();
  let data: unknown = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  if (!res.ok) {
    const detail = (data as { detail?: unknown } | null)?.detail ?? data;
    throw new ApiError(res.status, detail);
  }
  return data as T;
}

/** FastAPI 422 validációs válaszból emberi üzenet. */
export function validationMessage(err: unknown): string | null {
  if (!(err instanceof ApiError) || err.status !== 422) return null;
  const items = err.detail as Array<{ msg?: string; loc?: unknown[] }> | undefined;
  if (!Array.isArray(items) || !items.length) return "Hibás adat.";
  return items
    .map((i) => (i.msg ?? "").replace(/^Value error, /, ""))
    .filter(Boolean)
    .join(" ");
}

export function errorMessage(err: unknown, fallback = "Valami hiba történt. Próbáld újra."): string {
  return validationMessage(err) ?? (err instanceof ApiError ? err.message : fallback);
}
